import axios from '../utils/axios';

export default function getManagerTeam(adminId, params) {
    return axios.get(`/admin/${adminId}/get-manager-team`, { params });
};
